"use client";

import React, { useState, useEffect } from "react";
import { Clock, Globe, Zap } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
export default function GlobalAvailability() {
  const [time, setTime] = useState<Date | null>(null);
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
    setTime(new Date());
    const timer = setInterval(() => {
      setTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formattedTime = time?.toLocaleTimeString("en-GB", {
    timeZone: "Europe/London",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false
  });
  return <section data-section-id="228590" id="hull-leicester-bases" className="bg-background text-foreground py-24 px-4 md:px-8 overflow-hidden relative">
      <div className="max-w-6xl mx-auto relative z-10">
        <div className="mb-12 text-center md:text-left">
          
          
        </div>

        <Card className="relative overflow-hidden border-border bg-card/40 backdrop-blur-md shadow-2xl rounded-none">
          <div className="absolute inset-0 pointer-events-none opacity-10 flex items-center justify-center overflow-hidden">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642088/img/dark_world_map_dotted.png" alt="World Map" className="w-full h-full object-cover min-w-[800px]" />
            <div className="absolute top-[38%] left-[48%] md:top-[38%] md:left-[48.5%] w-3 h-3 bg-primary rounded-none shadow-[0_0_20px_4px_var(--color-primary)] animate-pulse" />
          </div>

          <CardContent className="relative z-10 p-8 md:p-16 grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-8 items-center">
            <div className="flex flex-col items-center md:items-start space-y-6">
              <div className="flex items-center space-x-3 text-muted-foreground">
                
                
              </div>
              
              <div className="text-5xl md:text-7xl font-mono font-bold text-foreground tracking-tighter tabular-nums drop-shadow-md">
                {mounted && formattedTime ? formattedTime : <span className="opacity-0">00:00:00</span>}
              </div>
              
              <div className="flex items-center space-x-2 text-lg text-muted-foreground font-mono bg-background/50 px-4 py-1.5 rounded-none border border-border">
                <Clock className="w-4 h-4" />
                <span>53.7443° N, 0.3325° W</span>
              </div>
            </div>

            <div className="h-px w-full bg-border md:hidden" />

            <div className="flex flex-col items-center md:items-start space-y-6 md:pl-12 md:border-l border-border">
              <div className="flex items-center space-x-3 text-muted-foreground">
                
                
              </div>
              
              <div className="text-3xl md:text-4xl font-default font-semibold uppercase">
                Remote & Mobile
              </div>
              
              <Badge variant="default" className="text-lg py-1.5 px-5 bg-primary text-primary-foreground shadow-lg rounded-none font-mono">
                Available for Travel
              </Badge>
              
              <p className="text-sm text-muted-foreground text-center md:text-left max-w-xs leading-relaxed font-sans">
                Fully equipped for remote mixing and mastering. Mobile recording rigs available for on-location sessions across the Midlands and East Yorkshire.
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>;
}